import { render, staticRenderFns } from "./RemoveBastion.vue?vue&type=template&id=d7be01c8&"
import script from "./RemoveBastion.vue?vue&type=script&lang=js&"
export * from "./RemoveBastion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports